export interface IAuthReducer {
  isAuth: boolean
}
export const authInitialState:IAuthReducer = {
  isAuth: false
};
